const defaultCategories = {
	experiment: ['Monetization', 'Pricing', 'Paywall'],
	parameter: ['Internal', 'External', 'Other'],
	status: ['started', 'ended', 'created']
};

export default defaultCategories;
